<template>
<div class="chapter">
<div class="inner_page">
<p class="fm1">Who durst be so bold with a few crooked boards nailed together, a stick standing upright, and a rag tied to it, to adventure into the ocean?</p>
<p class="fm2"><span class="smallcaps">THOMAS FULLER</span></p>
<p class="fm">Bravery never goes out of fashion.</p>
<p class="fm2"><span class="smallcaps">WILLIAM MAKEPEACE THACKERAY</span></p>
<p class="fm">We reached Dunkirk at 3am, where we put up. A very bloody sight.</p>
<p class="fm2"><span class="smallcaps">SUB-LIEUTENANT EDWARD BERTHON, RN, A SURVIVOR</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Fm1.vue?480e63ab